<template>
  <ListPageShell>
    <!-- 顶部导航栏 -->
    <template #header>
      <div class="list-page-panel is-header-minimal px-4 md:px-6 py-3">
        <div class="flex items-center justify-between">
        <!-- 左侧：页面标题和日历视图切换 -->
        <div class="flex items-center gap-4 md:gap-6">
          <div class="flex items-center gap-3">
            <div class="w-9 h-9 rounded-lg bg-blue-500 flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
            </div>
            <div class="list-page-heading-main hidden sm:block">
              <h1 class="text-lg font-semibold text-slate-900">日程管理</h1>
              <p class="text-xs text-slate-500">{{ formattedDate }}</p>
            </div>
          </div>

          <!-- 视图切换 -->
          <div class="hidden md:flex items-center bg-slate-100 rounded-lg p-1">
            <button
              v-for="view in calendarViews"
              :key="view.value"
              @click="switchView(view.value)"
              :class="[
                'px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200',
                currentView === view.value
                  ? 'bg-white text-slate-900 shadow-sm'
                  : 'text-slate-600 hover:text-slate-900'
              ]"
            >
              {{ view.label }}
            </button>
          </div>
        </div>

        <!-- 右侧：操作按钮 -->
        <div class="flex items-center gap-2 md:gap-3">
          <!-- 日期导航 -->
          <div class="flex items-center gap-1 md:gap-2 bg-slate-100 rounded-lg px-2 md:px-3 py-1.5">
            <button @click="navigateDate(-1)" class="p-1 hover:bg-white rounded-md transition-colors cursor-pointer" title="上一天/周/月">
              <svg class="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
              </svg>
            </button>
            <span class="text-xs md:text-sm font-medium text-slate-700 min-w-[100px] md:min-w-[140px] text-center">{{ navigationDate }}</span>
            <button @click="navigateDate(1)" class="p-1 hover:bg-white rounded-md transition-colors cursor-pointer" title="下一天/周/月">
              <svg class="w-4 h-4 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
          </div>

          <!-- 今天按钮 -->
          <button
            @click="goToToday"
            class="btn-secondary hidden sm:inline-flex items-center"
            title="快捷键: T"
          >
            今天
          </button>

          <!-- 新建日程按钮 -->
          <button
            @click="openCreateModal"
            class="btn-primary inline-flex items-center gap-2"
            title="快捷键: N"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            <span class="hidden sm:inline">新建日程</span>
          </button>
        </div>
      </div>
      </div>
    </template>

    <!-- 移动端视图切换 -->
    <div class="md:hidden flex items-center gap-2 px-4 md:px-6 py-2 bg-white border-b border-slate-200 overflow-x-auto">
      <button
        v-for="view in calendarViews"
        :key="view.value"
        @click="switchView(view.value)"
        :class="[
          'px-3 py-1.5 text-sm font-medium rounded-md transition-all whitespace-nowrap',
          currentView === view.value
            ? 'bg-blue-500 text-white'
            : 'bg-slate-100 text-slate-600'
        ]"
      >
        {{ view.label }}
      </button>
    </div>

    <div class="flex">
      <!-- 左侧边栏：日历筛选 -->
      <aside class="w-56 md:w-64 flex-shrink-0 border-r border-slate-200 bg-white p-3 md:p-4 hidden lg:block">
        <!-- 我的日历 -->
        <!-- <div class="mb-6">
          <h3 class="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">我的日历</h3>
          <div class="space-y-2">
            <label
              v-for="calendar in myCalendars"
              :key="calendar.id"
              class="flex items-center gap-3 cursor-pointer group"
            >
              <input
                type="checkbox"
                v-model="calendar.visible"
                class="w-4 h-4 rounded border-slate-300 text-blue-500 focus:ring-blue-500 cursor-pointer"
              />
              <span
                class="w-3 h-3 rounded-full flex-shrink-0"
                :style="{ backgroundColor: calendar.color }"
              ></span>
              <span class="text-sm text-slate-700 group-hover:text-slate-900">{{ calendar.name }}</span>
            </label>
          </div>
        </div> -->

        <!-- 日历类型筛选 -->
        <div class="mb-6">
          <h3 class="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">日程类型</h3>
          <div class="space-y-2">
            <label
              v-for="type in eventTypes"
              :key="type.value"
              class="flex items-center gap-3 cursor-pointer"
            >
              <input
                type="checkbox"
                v-model="type.visible"
                class="w-4 h-4 rounded border-slate-300 text-blue-500 focus:ring-blue-500 cursor-pointer"
              />
              <span
                class="w-2 h-2 rounded-full"
                :style="{ backgroundColor: type.color }"
              ></span>
              <span class="text-sm text-slate-700">{{ type.label }}</span>
            </label>
          </div>
        </div>

        <!-- 快捷筛选 -->
        <div class="mb-6">
          <h3 class="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">快捷筛选</h3>
          <div class="space-y-1">
            <button
              v-for="filter in quickFilters"
              :key="filter.value"
              @click="activeFilter = filter.value"
              :class="[
                'w-full flex items-center gap-3 px-3 py-2 text-sm rounded-lg transition-colors cursor-pointer',
                activeFilter === filter.value
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-slate-600 hover:bg-slate-50'
              ]"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              {{ filter.label }}
            </button>
          </div>
        </div>

        <!-- 待办事项 -->
        <!-- <div>
          <div class="flex items-center justify-between mb-3">
            <h3 class="text-xs font-semibold text-slate-500 uppercase tracking-wider">待办事项</h3>
            <button
              @click="addQuickTodo"
              class="text-xs text-blue-600 hover:text-blue-700 cursor-pointer"
            >
              + 添加
            </button>
          </div>
          <div class="space-y-2">
            <div
              v-for="task in pendingTasks"
              :key="task.id"
              class="flex items-start gap-2 p-2 bg-slate-50 rounded-lg group"
            >
              <input
                type="checkbox"
                v-model="task.completed"
                @change="toggleTask(task)"
                class="mt-0.5 w-4 h-4 rounded border-slate-300 text-blue-500 focus:ring-blue-500 cursor-pointer"
              />
              <div class="flex-1 min-w-0">
                <p :class="['text-sm', task.completed ? 'text-slate-400 line-through' : 'text-slate-700']">
                  {{ task.title }}
                </p>
                <p class="text-xs text-slate-400">{{ task.time }}</p>
              </div>
              <button
                @click="deleteTask(task.id)"
                class="opacity-0 group-hover:opacity-100 p-1 text-slate-400 hover:text-red-500 transition-all cursor-pointer"
              >
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
            </div>
            <p v-if="pendingTasks.length === 0" class="text-sm text-slate-400 text-center py-4">
              暂无待办
            </p>
          </div>
        </div> -->
      </aside>

      <!-- 主日历区域 -->
      <main class="flex-1 p-3 md:p-4">
        <!-- 加载状态 -->
        <div v-if="loading" class="bg-white rounded-xl border border-slate-200 p-8 text-center">
          <div class="inline-flex items-center gap-2 text-slate-500">
            <svg class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>加载中...</span>
          </div>
        </div>

        <!-- 月视图 -->
        <div v-show="!loading && currentView === 'month'" class="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <!-- 星期标题 -->
          <div class="grid grid-cols-7 border-b border-slate-200">
            <div
              v-for="day in weekDays"
              :key="day"
              class="py-2 md:py-3 text-center text-xs md:text-sm font-medium text-slate-500"
            >
              {{ day }}
            </div>
          </div>

          <!-- 日期网格 -->
          <div class="grid grid-cols-7">
            <div
              v-for="(day, index) in calendarDays"
              :key="index"
              :class="[
                'min-h-[80px] md:min-h-[120px] p-1 md:p-2 border-b border-r border-slate-100 transition-colors cursor-pointer',
                !day.isCurrentMonth ? 'bg-slate-50' : 'bg-white',
                day.isToday ? 'bg-blue-50/50' : '',
                'hover:bg-slate-50'
              ]"
              @click="selectDate(day)"
              @contextmenu.prevent="handleContextMenu($event, day)"
            >
              <div class="flex items-center justify-between mb-1">
                <span
                  :class="[
                    'w-5 h-5 md:w-7 md:h-7 flex items-center justify-center text-xs md:text-sm rounded-full',
                    day.isToday
                      ? 'bg-blue-500 text-white font-semibold'
                      : day.isCurrentMonth
                      ? 'text-slate-900'
                      : 'text-slate-400'
                  ]"
                >
                  {{ day.date }}
                </span>
                <span v-if="day.events.length > 0" class="text-xs text-slate-400 hidden sm:inline">
                  {{ day.events.length }}
                </span>
              </div>

              <!-- 事件列表 -->
              <div class="space-y-0.5 md:space-y-1">
                <div v-if="day.events.length > 0" class="hidden">
                  {{ debugDayEvents(day) }}
                </div>
                <div
                  v-for="event in day.events.slice(0, 3)"
                  :key="event.id"
                  @click.stop="viewEvent(event)"
                  @contextmenu.stop.prevent="handleEventContextMenu($event, event)"
                  class="group relative px-1 md:px-2 py-0.5 md:py-1 rounded text-xs cursor-pointer transition-all hover:bg-slate-100"
                >
                  <div :class="['absolute left-0 top-0 bottom-0 w-0.5 rounded-l', getEventBorderClass(event.type)]"></div>
                  <div class="pl-1.5 md:pl-2">
                    <span class="hidden md:inline text-slate-400 mr-1">{{ event.time }}</span>
                    <span class="text-slate-700 group-hover:text-slate-900">{{ event.title }}</span>
                    <!-- 待定邀请的视觉提示 -->
                    <span v-if="isPendingInvite(event)" class="ml-1 inline-flex items-center gap-0.5">
                      <span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span>
                      <span class="text-[10px] font-medium text-amber-600">待处理</span>
                    </span>
                    <!-- 非待定的已接受/已拒绝状态 -->
                    <span v-else-if="!event.isOwner && event.attendeeStatus" :class="['ml-1 text-[10px] font-medium', getAttendeeStatusLabel(event.attendeeStatus).class]">
                      {{ getAttendeeStatusLabel(event.attendeeStatus).label }}
                    </span>
                  </div>
                </div>
                <div
                  v-if="day.events.length > 3"
                  class="text-xs text-slate-500 px-1 md:px-2 cursor-pointer hover:text-blue-600"
                >
                  +{{ day.events.length - 3 }} 更多
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 周视图 -->
        <div v-show="!loading && currentView === 'week'" class="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <!-- 时间轴头部 -->
          <div class="grid grid-cols-8 border-b border-slate-200">
            <div class="p-2 md:p-3 border-r border-slate-200"></div>
            <div
              v-for="day in weekDates"
              :key="day.date"
              :class="[
                'p-2 md:p-3 text-center border-r border-slate-200 last:border-r-0 cursor-pointer',
                day.isToday ? 'bg-blue-50' : ''
              ]"
              @click="goToDate(day.date)"
            >
              <p class="text-xs text-slate-500">{{ day.weekday }}</p>
              <p :class="['text-sm md:text-lg font-semibold', day.isToday ? 'text-blue-600' : 'text-slate-900']">
                {{ day.day }}
              </p>
            </div>
          </div>

          <!-- 时间轴主体 -->
          <div class="max-h-[400px] md:max-h-[600px] overflow-y-auto">
            <div class="grid grid-cols-8">
              <!-- 时间列 -->
              <div class="border-r border-slate-200">
                <div
                  v-for="hour in hours"
                  :key="hour"
                  class="h-12 md:h-16 border-b border-slate-100 p-1 md:p-1"
                >
                  <span class="text-xs text-slate-400 hidden md:inline">{{ hour }}:00</span>
                  <span class="text-xs text-slate-400 md:hidden">{{ hour }}:00</span>
                </div>
              </div>

              <!-- 每天的列 -->
              <div
                v-for="day in weekDates"
                :key="day.date"
                :class="[
                  'relative border-r border-slate-200 last:border-r-0',
                  day.isToday ? 'bg-blue-50/30' : ''
                ]"
                @click="handleTimeSlotClick(day, $event)"
                @contextmenu.prevent="handleContextMenu($event, day)"
              >
                <!-- 网格线 -->
                <div
                  v-for="hour in hours"
                  :key="hour"
                  class="h-12 md:h-16 border-b border-slate-100"
                ></div>

                <!-- 事件块 (支持拖拽) -->
                <div
                  v-for="event in getWeekEvents(day.date)"
                  :key="event.id"
                  @click.stop="viewEvent(event)"
                  @contextmenu.stop.prevent="handleEventContextMenu($event, event)"
                  draggable="true"
                  @dragstart="handleDragStart($event, event)"
                  @dragend="handleDragEnd"
                  :class="[
                    'absolute left-0.5 right-0.5 rounded-lg p-1 md:p-2 cursor-move transition-all hover:shadow-md hover:scale-[1.02]',
                    getEventClass(event.type),
                    isDraggingEvent && draggedEvent?.id === event.id ? 'opacity-50' : ''
                  ]"
                  :style="getEventStyle(event)"
                >
                  <div class="flex items-start justify-between gap-1">
                    <div class="flex-1 min-w-0">
                      <p class="text-xs font-medium truncate hidden md:block">{{ event.title }}</p>
                      <p class="text-xs font-medium truncate md:hidden">{{ event.title.substring(0, 4) }}...</p>
                      <p class="text-xs opacity-75 hidden md:block">{{ event.time }}</p>
                      <!-- 被邀请的状态标签 -->
                      <span v-if="!event.isOwner" :class="['mt-1 inline-block px-2 py-0.5 rounded text-xs font-medium', getAttendeeStatusLabel(event.attendeeStatus).class]">
                        {{ getAttendeeStatusLabel(event.attendeeStatus).label }}
                      </span>
                    </div>
                    <!-- 待定邀请的操作按钮（仅图标，显示在右侧） -->
                    <div v-if="isPendingInvite(event)" class="flex items-center gap-0.5 flex-shrink-0">
                      <button @click.stop="respondToInvite(event, 2)" class="p-1 rounded bg-green-100 hover:bg-green-200 text-green-700 transition-colors" title="接受">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                        </svg>
                      </button>
                      <button @click.stop="respondToInvite(event, 3)" class="p-1 rounded bg-red-100 hover:bg-red-200 text-red-700 transition-colors" title="拒绝">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 日视图 -->
        <div v-show="!loading && currentView === 'day'" class="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div class="flex">
            <!-- 时间轴 -->
            <div class="w-12 md:w-16 flex-shrink-0 border-r border-slate-200">
              <div class="h-14 border-b border-slate-200"></div>
              <div
                v-for="hour in hours"
                :key="hour"
                class="h-12 md:h-16 border-b border-slate-100 p-1"
              >
                <span class="text-xs text-slate-400">{{ hour }}:00</span>
              </div>
            </div>

            <!-- 当天事件 -->
            <div class="flex-1 relative">
              <div
                v-for="hour in hours"
                :key="hour"
                class="h-12 md:h-16 border-b border-slate-100 relative"
                @click="handleTimeSlotClick(null, $event)"
              >
                <!-- 当前时间线 -->
                <div
                  v-if="currentDayDate === today && hour === currentHour"
                  class="absolute left-0 right-0 flex items-center z-10"
                  style="top: 50%"
                >
                  <div class="w-2 h-2 rounded-full bg-red-500"></div>
                  <div class="flex-1 h-0.5 bg-red-400"></div>
                </div>
              </div>

              <!-- 事件块 -->
              <div
                v-for="event in getDayEvents(currentDayDate)"
                :key="event.id"
                @click="viewEvent(event)"
                @contextmenu.stop.prevent="handleEventContextMenu($event, event)"
                draggable="true"
                @dragstart="handleDragStart($event, event)"
                @dragend="handleDragEnd"
                :class="[
                  'absolute left-2 right-2 rounded-xl p-3 md:p-4 cursor-pointer transition-all hover:shadow-lg',
                  getEventClass(event.type),
                  isDraggingEvent && draggedEvent?.id === event.id ? 'opacity-50' : ''
                ]"
                :style="getDayEventStyle(event)"
              >
                <div class="flex items-start justify-between mb-2">
                  <div class="flex items-center gap-2 flex-wrap">
                    <span class="text-sm font-semibold">{{ event.time }}</span>
                    <span :class="['px-2 py-0.5 rounded text-xs', getTypeBadgeClass(event.type)]">
                      {{ getTypeLabel(event.type) }}
                    </span>
                    <!-- 被邀请的状态标签 -->
                    <span v-if="!event.isOwner" :class="['px-2 py-0.5 rounded text-xs font-medium', getAttendeeStatusLabel(event.attendeeStatus).class]">
                      {{ getAttendeeStatusLabel(event.attendeeStatus).label }}
                    </span>
                  </div>
                  <div class="flex items-center gap-1">
                    <button
                      v-if="event.isOwner"
                      @click.stop="editEvent(event)"
                      class="p-1.5 hover:bg-white/50 rounded transition-colors cursor-pointer text-slate-500 hover:text-blue-600"
                      title="编辑"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                    </button>
                    <button
                      v-if="event.isOwner"
                      @click.stop="confirmDelete(event)"
                      class="p-1.5 hover:bg-red-50 rounded transition-colors cursor-pointer text-slate-500 hover:text-red-600"
                      title="删除"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                    <!-- 待定邀请的操作按钮 -->
                    <template v-if="isPendingInvite(event)">
                      <button
                        @click.stop="respondToInvite(event, 2)"
                        class="p-1.5 hover:bg-green-50 rounded transition-colors cursor-pointer text-green-600 hover:text-green-700"
                        title="接受"
                      >
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                        </svg>
                      </button>
                      <button
                        @click.stop="respondToInvite(event, 3)"
                        class="p-1.5 hover:bg-red-50 rounded transition-colors cursor-pointer text-red-600 hover:text-red-700"
                        title="拒绝"
                      >
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                      </button>
                    </template>
                  </div>
                </div>
                <h4 class="text-base font-semibold text-slate-900 mb-1">{{ event.title }}</h4>
                <p v-if="event.description" class="text-sm text-slate-600 mb-2 line-clamp-2">{{ event.description }}</p>
                <div class="flex flex-wrap items-center gap-2 md:gap-4 text-xs text-slate-500">
                  <span v-if="event.location" class="flex items-center gap-1">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                    </svg>
                    {{ event.location }}
                  </span>
                  <span v-if="event.attendees" class="flex items-center gap-1">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
                    </svg>
                    {{ event.attendees }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 议程视图 -->
        <div v-show="!loading && currentView === 'agenda'" class="bg-white rounded-xl border border-slate-200">
          <div class="p-4 border-b border-slate-200 flex items-center justify-between">
            <h3 class="text-lg font-semibold text-slate-900">{{ agendaTitle }}</h3>
            <div class="flex items-center gap-2">
              <button
                @click="switchView('day')"
                class="text-sm text-blue-600 hover:text-blue-700 cursor-pointer"
              >
                切换日视图
              </button>
            </div>
          </div>
          <div class="divide-y divide-slate-100">
            <div
              v-for="group in agendaGroups"
              :key="group.date"
              class="p-4"
            >
              <div class="flex items-center gap-3 mb-4">
                <span class="text-sm font-semibold text-slate-900">{{ group.label }}</span>
                <span class="text-xs text-slate-500">({{ group.events.length }}个日程)</span>
              </div>
              <div class="space-y-3">
                <div
                  v-for="event in group.events"
                  :key="event.id"
                  @click="viewEvent(event)"
                  @contextmenu.stop.prevent="handleEventContextMenu($event, event)"
                  class="flex items-start gap-4 p-4 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-md transition-all cursor-pointer bg-white group"
                >
                  <div :class="['w-1 self-stretch rounded-full flex-shrink-0', getEventBorderClass(event.type)]"></div>
                  <div class="flex-1 min-w-0">
                    <div class="flex items-center gap-2 mb-1 flex-wrap">
                      <span class="text-sm font-medium text-slate-900">{{ event.time }}</span>
                      <span :class="['px-2 py-0.5 rounded text-xs', getTypeBadgeClass(event.type)]">
                        {{ getTypeLabel(event.type) }}
                      </span>
                    </div>
                    <h4 class="text-base font-semibold text-slate-900 mb-1">{{ event.title }}</h4>
                    <p v-if="event.description" class="text-sm text-slate-600 mb-2 line-clamp-2">{{ event.description }}</p>
                    <div class="flex flex-wrap items-center gap-2 md:gap-4 text-xs text-slate-500">
                      <span v-if="event.location" class="flex items-center gap-1">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                        </svg>
                        {{ event.location }}
                      </span>
                      <span v-if="event.attendees" class="flex items-center gap-1">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
                        </svg>
                        {{ event.attendees }}
                      </span>
                    </div>
                  </div>
                  <div class="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                    <button
                      @click.stop="editEvent(event)"
                      class="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer"
                      title="编辑"
                    >
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"/>
                      </svg>
                    </button>
                    <button
                      v-if="event.isOwner"
                      @click.stop="confirmDelete(event)"
                      class="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
                      title="删除"
                    >
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                    <button
                      v-else-if="event.attendeeStatus === 1"
                      @click.stop="respondToInvite(event, 3)"
                      class="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
                      title="取消参与"
                    >
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                    </button>
                  </div>
                </div>
                <p v-if="group.events.length === 0" class="text-sm text-slate-400 text-center py-4">
                  暂无日程
                </p>
              </div>
            </div>
            <p v-if="agendaGroups.length === 0" class="text-sm text-slate-400 text-center py-8">
              暂无日程
            </p>
          </div>
        </div>
      </main>

      <!-- 右侧边栏：选中日期/事件详情 -->
      <aside v-if="selectedDate" class="w-72 md:w-80 flex-shrink-0 bg-white border-l border-slate-200 p-4 hidden xl:block">
        <div class="mb-6">
          <h3 class="text-sm font-semibold text-slate-900 mb-2">{{ formatSelectedDate }}</h3>
          <p class="text-xs text-slate-500">{{ selectedDate.weekday }}</p>
        </div>

        <!-- 当天事件 -->
        <div class="mb-6">
          <div class="flex items-center justify-between mb-3">
            <h4 class="text-xs font-semibold text-slate-500 uppercase tracking-wider">今日日程</h4>
            <button
              @click="openCreateModalForDate(selectedDate.fullDate)"
              class="text-xs text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
            >
              + 添加
            </button>
          </div>
          <div class="space-y-2">
            <div
              v-for="event in getSelectedDateEvents()"
              :key="event.id"
              @click="viewEvent(event)"
              class="p-3 rounded-lg border border-slate-200 hover:border-blue-300 hover:shadow-sm transition-all cursor-pointer"
            >
              <div class="flex items-center gap-2 mb-1">
                <span :class="['w-2 h-2 rounded-full flex-shrink-0', getTypeDotClass(event.type)]"></span>
                <span class="text-xs font-medium text-slate-700">{{ event.time }}</span>
              </div>
              <p class="text-sm font-medium text-slate-900">{{ event.title }}</p>
            </div>
            <p v-if="getSelectedDateEvents().length === 0" class="text-sm text-slate-400 text-center py-4">
              暂无日程
            </p>
          </div>
        </div>

        <!-- 快捷日程联系人 -->
        <div>
          <h4 class="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">快捷日程</h4>
          <div class="space-y-2">
            <button
              v-for="contact in quickScheduleContacts"
              :key="contact.id"
              @click="scheduleWithContact(contact)"
              class="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-slate-50 transition-colors text-left cursor-pointer"
            >
              <img :src="contact.avatar" :alt="contact.name" class="w-8 h-8 rounded-full flex-shrink-0" />
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-slate-900 truncate">{{ contact.name }}</p>
                <p class="text-xs text-slate-500">{{ contact.company }}</p>
              </div>
              <svg class="w-4 h-4 text-slate-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
            </button>
          </div>
        </div>
      </aside>
    </div>

    <!-- 右键菜单 -->
    <ContextMenu
      v-model:visible="contextMenuVisible"
      :items="contextMenuItems"
      :x="contextMenuX"
      :y="contextMenuY"
      :event="contextMenuEvent"
      @select="handleContextMenuSelect"
      @close="contextMenuVisible = false"
    />

    <!-- 事件预览气泡 -->
    <EventTooltip
      v-model:visible="tooltipVisible"
      :event="tooltipEvent"
      :x="tooltipX"
      :y="tooltipY"
      @edit="editEvent"
      @delete="confirmDelete"
      @close="tooltipVisible = false"
    />

    <!-- 新建/编辑日程弹窗 -->
    <Teleport to="body">
      <Transition name="modal">
        <div
          v-if="showCreateModal"
          class="fixed inset-0 z-50 flex items-center justify-center p-4"
        >
          <!-- 遮罩层 -->
          <div
            class="absolute inset-0 bg-black/50"
            @click="closeModal"
          ></div>

          <!-- 弹窗内容 -->
          <div
            ref="modalRef"
            class="relative flex flex-col bg-white rounded-2xl shadow-2xl w-full max-w-lg h-[90vh]"
            role="dialog"
            aria-modal="true"
          >
            <!-- 头部 -->
            <div class="flex items-center justify-between p-6 border-b border-slate-200 shrink-0">
              <h2 class="text-xl font-semibold text-slate-900">
                {{ editingEvent ? '编辑日程' : '新建日程' }}
              </h2>
              <button
                @click="closeModal"
                class="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer"
                aria-label="关闭"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
            </div>

            <!-- 表单内容 -->
            <div class="flex-1 overflow-y-auto p-6 space-y-4">
              <!-- 标题 -->
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">
                  日程标题 <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="eventForm.title"
                  type="text"
                  placeholder="输入日程标题"
                  maxlength="200"
                  class="form-input w-full"
                  :class="[
                    'border-slate-200',
                    validation.errors.title ? 'border-red-500 focus:ring-red-500' : ''
                  ]"
                  @blur="validateField('title')"
                />
                <p v-if="validation.errors.title" class="mt-1 text-sm text-red-500">{{ validation.errors.title }}</p>
              </div>

              <!-- 日期时间 -->
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">
                    开始日期 <span class="text-red-500">*</span>
                  </label>
                  <el-date-picker
                    v-model="eventForm.startDate"
                    type="date"
                    format="YYYY年MM月DD日"
                    value-format="YYYY-MM-DD"
                    placeholder="请选择开始日期"
                    class="w-full"
                    @change="onStartDateChange"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">
                    开始时间 <span class="text-red-500">*</span>
                  </label>
                  <el-time-picker
                    v-model="eventForm.startTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="请选择开始时间"
                    class="w-full"
                    @change="onStartTimeChange"
                  />
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">结束日期</label>
                  <el-date-picker
                    v-model="eventForm.endDate"
                    type="date"
                    format="YYYY年MM月DD日"
                    value-format="YYYY-MM-DD"
                    placeholder="请选择结束日期"
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">结束时间</label>
                  <el-time-picker
                    v-model="eventForm.endTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="请选择结束时间"
                    class="w-full"
                  />
                </div>
              </div>

              <!-- 提醒设置 -->
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">提醒时间</label>
                <el-select
                  v-model="eventForm.reminderBefore"
                  class="form-select w-full"
                >
                  <el-option label="不提醒" :value="0" />
                  <el-option label="5分钟前" :value="5" />
                  <el-option label="15分钟前" :value="15" />
                  <el-option label="30分钟前" :value="30" />
                  <el-option label="1小时前" :value="60" />
                  <el-option label="1天前" :value="1440" />
                </el-select>
              </div>

              <!-- 日程类型 -->
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-2">日程类型</label>
                <div class="flex flex-wrap gap-2">
                  <button
                    v-for="type in eventTypes"
                    :key="type.value"
                    @click="eventForm.type = type.value"
                    type="button"
                    :class="[
                      'px-3 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer',
                      eventForm.type === type.value
                        ? 'ring-2 ring-offset-2 ring-blue-500 text-white'
                        : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                    ]"
                    :style="eventForm.type === type.value ? { backgroundColor: type.color } : {}"
                  >
                    {{ type.label }}
                  </button>
                </div>
              </div>

              <!-- 地点 -->
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">地点</label>
                <input
                  v-model="eventForm.location"
                  type="text"
                  placeholder="输入地点或选择会议室"
                  class="form-input w-full"
                />
              </div>

              <!-- 参与人 -->
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">参与人</label>
                <UserSelector
                  v-model="eventForm.attendeeUserIds"
                  multiple
                  placeholder="点击选择参与人"
                />
              </div>

              <!-- 描述 -->
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">描述</label>
                <textarea
                  v-model="eventForm.description"
                  rows="3"
                  placeholder="添加日程描述"
                  maxlength="500"
                  class="form-textarea"
                ></textarea>
                <p class="text-xs text-slate-400 text-right mt-1">{{ eventForm.description.length }}/500</p>
              </div>

              <!-- CRM关联 -->
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">关联CRM</label>
                <el-select
                  v-model="eventForm.customerId"
                  class="form-select w-full"
                >
                  <el-option label="无关联" :value="null" />
                  <el-option label="客户示例" value="1" />
                </el-select>
              </div>
            </div>

            <!-- 底部按钮 -->
            <div class="flex items-center justify-between p-6 border-t border-slate-200 shrink-0">
              <button
                v-if="editingEvent && editingEvent.isOwner"
                @click="confirmDelete(editingEvent)"
                type="button"
                class="px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
              >
                删除
              </button>
              <button
                v-else-if="editingEvent && !editingEvent.isOwner && editingEvent.attendeeStatus === 1"
                @click="respondToInvite(editingEvent, 3); closeModal()"
                type="button"
                class="px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
              >
                取消参与
              </button>
              <div class="flex gap-3 ml-auto">
                <button
                  @click="closeModal"
                  type="button"
                  class="px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors cursor-pointer"
                >
                  取消
                </button>
                <button
                  @click="saveEvent"
                  type="button"
                  :disabled="saving"
                  class="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50 cursor-pointer"
                >
                  <span v-if="saving">保存中...</span>
                  <span v-else>保存</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>

    <!-- 事件详情弹窗 -->
    <ScheduleDetailModal
      :show="showEventDetail"
      :event="detailEvent"
      :loading="detailLoading"
      @close="showEventDetail = false"
      @edit="editEvent(detailEvent)"
      @accept="() => respondToInvite(detailEvent, 2)"
      @decline="() => respondToInvite(detailEvent, 3)"
      @cancel="() => respondToInvite(detailEvent, 3)"
    />

    <!-- 删除确认对话框 -->
    <Teleport to="body">
      <Transition name="modal">
        <div
          v-if="showDeleteConfirm"
          class="fixed inset-0 z-50 flex items-center justify-center p-4"
        >
          <div
            class="absolute inset-0 bg-black/50"
            @click="showDeleteConfirm = false"
          ></div>
          <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 p-6">
            <div class="text-center">
              <div class="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
                <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-slate-900 mb-2">确认删除</h3>
              <p class="text-sm text-slate-600 mb-6">确定要删除「{{ deleteTarget?.title }}」吗？此操作不可恢复。</p>
              <div class="flex gap-3">
                <button
                  @click="showDeleteConfirm = false"
                  type="button"
                  class="flex-1 px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors cursor-pointer"
                >
                  取消
                </button>
                <button
                  @click="handleDelete"
                  type="button"
                  class="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors cursor-pointer"
                >
                  删除
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>

    <!-- 键盘快捷键提示 -->
    <Transition name="fade">
      <div
        v-if="showShortcuts"
        class="fixed bottom-4 right-4 z-50 bg-white rounded-xl shadow-lg border border-slate-200 p-4 w-64"
      >
        <div class="flex items-center justify-between mb-3">
          <h4 class="text-sm font-semibold text-slate-900">键盘快捷键</h4>
          <button
            @click="showShortcuts = false"
            class="p-1 text-slate-400 hover:text-slate-600 cursor-pointer"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="space-y-2 text-sm">
          <div v-for="shortcut in shortcutList" :key="shortcut.key" class="flex items-center justify-between">
            <span class="text-slate-600">{{ shortcut.label }}</span>
            <kbd class="px-2 py-0.5 bg-slate-100 rounded text-xs text-slate-700 font-mono">{{ shortcut.key }}</kbd>
          </div>
        </div>
      </div>
    </Transition>
  </ListPageShell>
</template>

<script setup>
import { ref, computed, reactive, onMounted, onUnmounted, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import ContextMenu from './components/ContextMenu/ContextMenu.vue'
import EventTooltip from './components/EventTooltip/EventTooltip.vue'
import ListPageShell from '@/components/ListPageShell.vue'
import UserSelector from '@/components/UserSelector/index.vue'
import ScheduleDetailModal from '@/components/ScheduleDetailModal.vue'
import { useDrag } from '@/composables/useDrag'
import { useKeyboard } from '@/composables/useKeyboard'
import { useValidation } from '@/composables/useValidation'
import { scheduleApi } from '@/api/schedule'
import { useUserStore } from '@/stores/user'

// 视图类型
const calendarViews = [
  { label: '月', value: 'month' },
  { label: '周', value: 'week' },
  { label: '日', value: 'day' },
  { label: '议程', value: 'agenda' }
]

// 状态
const currentView = ref('month')
const currentDate = ref(new Date())
const selectedDate = ref(null)
const activeFilter = ref('all')
const loading = ref(false)
const saving = ref(false)
const showCreateModal = ref(false)
const showEventDetail = ref(false)
const showDeleteConfirm = ref(false)
const showShortcuts = ref(false)
const editingEvent = ref(null)
const detailLoading = ref(false)
const detailEvent = ref({})
const deleteTarget = ref(null)
const modalRef = ref(null)

// 用户store (用于API请求认证)
const userStore = useUserStore() // eslint-disable-line no-unused-vars

// 日程列表
const events = ref([])
const pagination = reactive({
  current: 1,
  size: 100,
  total: 0
})

// 我的日历
// const myCalendars = reactive([
//   { id: 1, name: '工作日历', color: '#3B82F6', visible: true, type: 1 },
//   { id: 2, name: '个人日历', color: '#10B981', visible: true, type: 2 },
//   { id: 3, name: '团队日历', color: '#F59E0B', visible: true, type: 3 },
//   { id: 4, name: '客户日历', color: '#8B5CF6', visible: false, type: 4 }
// ])

// 日程类型映射（后端类型 -> 前端类型）
const typeMap = {
  MEETING: { value: 'meeting', label: '会议', color: '#3B82F6' },
  TASK: { value: 'task', label: '任务', color: '#F59E0B' },
  CALL: { value: 'call', label: '电话', color: '#10B981' },
  DEADLINE: { value: 'deadline', label: '截止', color: '#EF4444' },
  OTHER: { value: 'other', label: '其他', color: '#6B7280' }
}

// 日程类型（用于表单选择，使用后端类型值）
const eventTypes = reactive([
  { value: 'MEETING', label: '会议', color: '#3B82F6', visible: true },
  { value: 'TASK', label: '任务', color: '#F59E0B', visible: true },
  { value: 'CALL', label: '电话', color: '#10B981', visible: true },
  { value: 'DEADLINE', label: '截止', color: '#EF4444', visible: true },
  { value: 'OTHER', label: '其他', color: '#6B7280', visible: true }
])

// 快捷筛选
const quickFilters = [
  { value: 'all', label: '全部日程' },
  { value: 'today', label: '今天的日程' },
  { value: 'week', label: '本周日程' },
  { value: 'important', label: '重要日程' }
]

// 待办事项
// const pendingTasks = reactive([
//   { id: 1, title: '准备季度汇报材料', time: '今天 14:00', completed: false },
//   { id: 2, title: '跟进客户反馈', time: '今天 16:00', completed: false },
//   { id: 3, title: '更新销售数据', time: '明天 10:00', completed: true }
// ])

// 星期
const weekDays = ['日', '一', '二', '三', '四', '五', '六']

// 小时
const hours = Array.from({ length: 24 }, (_, i) => i)

// 模拟事件数据（降级使用）
const mockEvents = [
  { id: 1, title: '项目启动会议', type: 'meeting', date: '2024-01-15', time: '09:00', duration: 90, location: '会议室A', attendees: '张三、李四', description: '讨论项目计划和分工', color: '#3B82F6' },
  { id: 2, title: '客户电话回访', type: 'call', date: '2024-01-15', time: '14:00', duration: 30, location: '', attendees: '王五', description: '跟进产品使用情况', color: '#10B981' },
  { id: 3, title: '提交季度报告', type: 'deadline', date: '2024-01-16', time: '17:00', duration: 0, location: '', attendees: '', description: '完成Q4数据分析报告', color: '#EF4444' },
  { id: 4, title: '团队周会', type: 'meeting', date: '2024-01-17', time: '10:00', duration: 60, location: '线上会议', attendees: '全体成员', description: '分享本周进展', color: '#3B82F6' },
  { id: 5, title: '合同评审', type: 'task', date: '2024-01-18', time: '15:00', duration: 45, location: '法务部', attendees: '法务小王', description: '评审新合同条款', color: '#F59E0B' },
  { id: 6, title: '产品演示', type: 'meeting', date: '2024-01-19', time: '11:00', duration: 60, location: '客户现场', attendees: '客户方全体', description: '向客户展示新产品功能', color: '#3B82F6' }
]

// 快捷联系人
const quickScheduleContacts = [
  { id: 1, name: '张三', company: 'ABC公司', avatar: 'https://i.pravatar.cc/100?img=1' },
  { id: 2, name: '李四', company: 'XYZ集团', avatar: 'https://i.pravatar.cc/100?img=2' },
  { id: 3, name: '王五', company: '123科技', avatar: 'https://i.pravatar.cc/100?img=3' }
]

// 表单数据（对接后端API）
const eventForm = reactive({
  title: '',
  startDate: '',
  startTime: '',
  endDate: '',
  endTime: '',
  type: 'MEETING',
  location: '',
  attendees: [],
  attendeeUserIds: [],
  description: '',
  customerId: null,
  opportunityId: null,
  contractId: null,
  projectId: null,
  isAllDay: 0,
  priority: 2,
  isImportant: 0,
  reminderEnabled: 1,
  reminderBefore: 15,
  repeatType: 0,
  color: ''
})

// 右键菜单状态
const contextMenuVisible = ref(false)
const contextMenuX = ref(0)
const contextMenuY = ref(0)
const contextMenuEvent = ref(null)
const contextMenuTarget = ref(null)

// 预览气泡状态
const tooltipVisible = ref(false)
const tooltipEvent = ref(null)
const tooltipX = ref(0)
const tooltipY = ref(0)

// 拖拽状态
const { isDragging: isDraggingEvent, dragData: draggedEvent, handleDragStart, handleDragEnd } = useDrag({
  onDragStart: (e, data) => {
    draggedEvent.value = data
  },
  onDragEnd: () => {
    draggedEvent.value = null
  }
})

// 验证
const validation = useValidation({
  rules: {
    title: [
      { required: true, message: '请输入日程标题', trigger: 'blur' },
      { min: 2, max: 200, message: '标题长度为2-200字符', trigger: 'blur' }
    ],
    startTime: [
      { required: true, message: '请选择开始时间', trigger: 'change' }
    ]
  }
})

// 键盘快捷键
const { initDefaultShortcuts, getShortcutTips } = useKeyboard({
  onKeydown: (e, action) => {
    handleKeyboardAction(action)
  }
})

const shortcutList = ref([])

// 初始化快捷键
onMounted(async () => {
  initDefaultShortcuts({
    createEvent: () => openCreateModal(),
    goToToday: () => goToToday(),
    navigatePrev: () => navigateDate(-1),
    navigateNext: () => navigateDate(1),
    switchMonthView: () => switchView('month'),
    switchWeekView: () => switchView('week'),
    switchDayView: () => switchView('day'),
    switchAgendaView: () => switchView('agenda'),
    closeModal: () => closeModal(),
    openSearch: () => toggleShortcuts()
  })

  shortcutList.value = getShortcutTips()

  // 点击其他区域关闭快捷键提示
  document.addEventListener('click', handleOutsideClick)

  // 获取日程数据
  await fetchEvents()
})

onUnmounted(() => {
  document.removeEventListener('click', handleOutsideClick)
})

// 获取日程列表
async function fetchEvents() {
  loading.value = true
  try {
    // 计算日期范围（月视图显示前后1个月的数据以确保完整性）
    const start = new Date(currentDate.value)
    start.setMonth(start.getMonth() - 1)
    start.setDate(1)
    const end = new Date(currentDate.value)
    end.setMonth(end.getMonth() + 2)
    end.setDate(0)

    // 格式化日期为 LocalDateTime 格式 (yyyy-MM-ddTHH:mm:ss)
    const formatLocalDateTime = (date) => {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const min = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${d}T${h}:${min}:${s}`
    }

    const params = {
      startTime: formatLocalDateTime(start),
      endTime: formatLocalDateTime(end)
    }
    const res = await scheduleApi.getAllByDateRange(params)
    console.log('[Schedule] API原始响应:', res)
    if (res) {
      // 处理数据
      if (Array.isArray(res)) {
        console.log('[Schedule] API返回数组长度:', res.length)
        if (res.length > 0) {
          console.log('[Schedule] 第一个日程数据:', res[0])
          console.log('[Schedule] isOwner字段:', res[0].isOwner)
          console.log('[Schedule] attendeeStatus字段:', res[0].attendeeStatus)
        }
        events.value = res.map(transformEvent)
        pagination.total = res.length
      } else {
        events.value = []
      }
    } else {
      // 接口未对接，使用模拟数据
      console.log('[Schedule] 使用模拟数据')
      events.value = mockEvents.map(transformEvent)
    }
  } catch (error) {
    console.error('[Schedule] 获取日程失败:', error)
    ElMessage.error('获取日程数据失败')
    // 降级使用模拟数据
    events.value = mockEvents.map(transformEvent)
  } finally {
    loading.value = false
  }
}

// 转换后端日程数据为前端格式
function transformEvent(event) {
  if (!event) return null

  // 解析开始时间（支持两种格式: yyyy-MM-ddTHH:mm:ss 和 yyyy-MM-dd HH:mm:ss）
  const startDateTime = event.startTime
  let date = ''
  let time = ''
  let duration = event.duration || 60

  if (startDateTime) {
    // 将空格格式转换为 T 格式，确保跨浏览器兼容
    const normalizedTime = startDateTime.replace(' ', 'T')
    const dt = new Date(normalizedTime)
    if (!isNaN(dt.getTime())) {
      date = dt.toISOString().split('T')[0]
      time = normalizedTime.includes('T')
        ? normalizedTime.split('T')[1]?.substring(0, 5)
        : '09:00'
    }
  }

  // 获取类型信息
  const backendType = event.type
  const typeInfo = typeMap[backendType] || typeMap.OTHER
  const frontendType = typeInfo.value

  // 计算结束时间
  let endDate = date
  let endTime = ''
  if (event.endTime) {
    const normalizedEndTime = event.endTime.replace(' ', 'T')
    const dt = new Date(normalizedEndTime)
    if (!isNaN(dt.getTime())) {
      endDate = dt.toISOString().split('T')[0]
      endTime = normalizedEndTime.includes('T')
        ? normalizedEndTime.split('T')[1]?.substring(0, 5)
        : '10:00'
    }
  }

  // 处理参与人
  let attendees = ''
  let attendeeList = []
  if (event.attendees && Array.isArray(event.attendees)) {
    attendeeList = event.attendees.map(a => ({
      id: a.userId,
      userId: a.userId,
      userName: a.userName || '',
      avatar: a.avatar || '',
      role: a.role,
      status: a.status
    }))
    attendees = event.attendees.map(a => a.userName || '').filter(Boolean).join('、')
  }

  const result = {
    id: event.id,
    title: event.title,
    type: frontendType,
    typeBackend: backendType, // 保存后端类型值
    date,
    time,
    duration,
    endDate,
    endTime,
    location: event.location || '',
    description: event.description || '',
    attendees,
    attendeeList,
    color: event.color || typeInfo.color,
    // CRM关联
    customerId: event.customerId,
    customerName: event.customerName || '',
    opportunityId: event.opportunityId,
    opportunityName: event.opportunityName || '',
    contractId: event.contractId,
    contractName: event.contractName || '',
    projectId: event.projectId,
    projectName: event.projectName || '',
    // 状态
    status: event.status,
    isAllDay: event.isAllDay,
    isImportant: event.isImportant,
    priority: event.priority,
    reminderEnabled: event.reminderEnabled,
    reminderBefore: event.reminderBefore,
    repeatType: event.repeatType,
    // 拥有者信息
    isOwner: event.isOwner,
    attendeeStatus: event.attendeeStatus,
    // 创建时间
    createdAt: event.createTime,
    updatedAt: event.updateTime
  }
  console.log('[Schedule] transformEvent结果:', result.isOwner, result.attendeeStatus)
  return result
}

// 获取日程参与人列表 (供后续参与人管理功能使用)
async function fetchAttendees(eventId) { // eslint-disable-line no-unused-vars
  try {
    const res = await scheduleApi.getAttendees(eventId)
    return res || []
  } catch (error) {
    console.error('[Schedule] 获取参与人失败:', error)
    return []
  }
}

// 添加参与人
async function addAttendees(eventId, userIds) { // eslint-disable-line no-unused-vars
  try {
    const res = await scheduleApi.addAttendees(eventId, { userIds })
    ElMessage.success('添加成功')
    return res
  } catch (error) {
    console.error('[Schedule] 添加参与人失败:', error)
    ElMessage.error('添加失败')
    return null
  }
}

// 移除参与人
async function removeAttendee(eventId, userId) { // eslint-disable-line no-unused-vars
  try {
    await scheduleApi.removeAttendee(eventId, userId)
    ElMessage.success('移除成功')
    return true
  } catch (error) {
    console.error('[Schedule] 移除参与人失败:', error)
    ElMessage.error('移除失败')
    return false
  }
}

// 响应邀请
async function respondInvite(eventId, userId, status) { // eslint-disable-line no-unused-vars
  try {
    await scheduleApi.responseInvite(eventId, userId, status)
    ElMessage.success('已响应')
    return true
  } catch (error) {
    console.error('[Schedule] 响应邀请失败:', error)
    ElMessage.error('响应失败')
    return false
  }
}

// 检查时间冲突
async function checkConflict(params) { // eslint-disable-line no-unused-vars
  try {
    const res = await scheduleApi.checkConflict(params)
    return res || []
  } catch (error) {
    console.error('[Schedule] 检查冲突失败:', error)
    return []
  }
}

// 完成日程
async function completeSchedule(eventId) { // eslint-disable-line no-unused-vars
  try {
    await scheduleApi.complete(eventId)
    ElMessage.success('已完成')
    // 更新本地状态
    const event = events.value.find(e => e.id === eventId)
    if (event) {
      event.status = 'COMPLETED'
    }
    return true
  } catch (error) {
    console.error('[Schedule] 完成日程失败:', error)
    ElMessage.error('操作失败')
    return false
  }
}

// 取消日程
async function cancelSchedule(eventId) { // eslint-disable-line no-unused-vars
  try {
    await scheduleApi.cancel(eventId)
    ElMessage.success('已取消')
    // 更新本地状态
    const event = events.value.find(e => e.id === eventId)
    if (event) {
      event.status = 'CANCELLED'
    }
    return true
  } catch (error) {
    console.error('[Schedule] 取消日程失败:', error)
    ElMessage.error('操作失败')
    return false
  }
}

// 格式化日期时间 (供后续使用)
function formatDateTime(dateStr, timeStr) { // eslint-disable-line no-unused-vars
  if (!dateStr) return ''
  const date = new Date(dateStr)
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${month}月${day}日 ${timeStr || ''}`
}

function handleOutsideClick(e) {
  if (!e.target.closest('.event-tooltip') && !e.target.closest('.context-menu')) {
    tooltipVisible.value = false
  }
  if (!e.target.closest('.context-menu') && !e.target.closest('.context-menu-backdrop')) {
    contextMenuVisible.value = false
  }
}

function handleKeyboardAction(action) {
  const actionMap = {
    create: openCreateModal,
    today: goToToday,
    prev: () => navigateDate(-1),
    next: () => navigateDate(1),
    monthView: () => switchView('month'),
    weekView: () => switchView('week'),
    dayView: () => switchView('day'),
    agendaView: () => switchView('agenda'),
    close: closeModal
  }
  actionMap[action]?.()
}

function toggleShortcuts() {
  showShortcuts.value = !showShortcuts.value
}

// 计算属性
const filteredEvents = computed(() => {
  let result = [...(events.value || [])]

  // 过滤掉 null 值
  result = result.filter(Boolean)

  // 按类型筛选（支持后端类型值）
  const visibleTypes = eventTypes.filter(t => t.visible).map(t => t.value)
  result = result.filter(e => {
    // 支持前端类型值(meeting/task)和后端类型值(MEETING/TASK)
    return visibleTypes.includes(e.type) || visibleTypes.includes(e.typeBackend)
  })

  // 按快捷筛选条件筛选
  const today = new Date().toISOString().split('T')[0]
  const weekStart = new Date()
  weekStart.setDate(weekStart.getDate() - weekStart.getDay())
  const weekEnd = new Date(weekStart)
  weekEnd.setDate(weekStart.getDate() + 6)
  const weekStartStr = weekStart.toISOString().split('T')[0]
  const weekEndStr = weekEnd.toISOString().split('T')[0]

  switch (activeFilter.value) {
    case 'today':
      result = result.filter(e => e.date === today)
      break
    case 'week':
      result = result.filter(e => e.date >= weekStartStr && e.date <= weekEndStr)
      break
    case 'important':
      result = result.filter(e => e.isImportant === 1 || e.priority === 1)
      break
    case 'all':
    default:
      // 全部显示，不做额外筛选
      break
  }

  return result
})

// 判断是否是被邀请且待定的日程
const isPendingInvite = (event) => {
  return event.isOwner === false && event.attendeeStatus === 1
}

// 获取参与状态标签
const getAttendeeStatusLabel = (status) => {
  const statusMap = {
    1: { label: '待定', class: 'bg-amber-100 text-amber-700' },
    2: { label: '已接受', class: 'bg-green-100 text-green-700' },
    3: { label: '已拒绝', class: 'bg-red-100 text-red-700' }
  }
  return statusMap[status] || { label: '未知', class: 'bg-slate-100 text-slate-700' }
}

// DEBUG: 调试月视图事件数据
function debugDayEvents(day) {
  if (day.events && day.events.length > 0) {
    console.log('[MonthView] 日期:', day.fullDate, '事件数:', day.events.length)
    day.events.forEach((e, i) => {
      if (i < 3) {
        console.log(`  事件${i}: isOwner=${e.isOwner}, attendeeStatus=${e.attendeeStatus}, title=${e.title}`)
      }
    })
  }
  return ''
}

// 响应邀请（接受/拒绝）
async function respondToInvite(event, status) {
  try {
    await scheduleApi.responseInvite(event.id, status)
    ElMessage.success(status === 2 ? '已接受邀请' : '已拒绝邀请')
    // 刷新列表
    await fetchEvents()
    // 如果详情页打开，重新获取详情以刷新参与人状态
    if (showEventDetail.value && detailEvent.value.id === event.id) {
      const res = await scheduleApi.getDetail(event.id)
      if (res) {
        // 处理参与人列表
        let attendeeList = []
        let attendeesStr = ''
        if (res.attendees && Array.isArray(res.attendees)) {
          attendeeList = res.attendees.map(a => ({
            id: a.id,
            userId: a.userId,
            userName: a.userName || '',
            avatar: a.avatar || '',
            role: a.role,
            status: a.status
          }))
          attendeesStr = res.attendees.map(a => a.userName || '').filter(Boolean).join('、')
        }
        // 更新详情数据
        detailEvent.value = {
          ...detailEvent.value,
          ...res,
          attendees: attendeesStr,
          attendeeList
        }
      }
    }
    return true
  } catch (error) {
    console.error('[Schedule] 响应邀请失败:', error)
    ElMessage.error('操作失败')
    return false
  }
}

const formattedDate = computed(() => {
  return currentDate.value.toLocaleDateString('zh-CN', { year: 'numeric', month: 'long' })
})

const formatSelectedDate = computed(() => {
  if (!selectedDate.value) return ''
  const date = new Date(selectedDate.value.fullDate)
  return date.toLocaleDateString('zh-CN', { month: 'long', day: 'numeric' })
})

const navigationDate = computed(() => {
  const year = currentDate.value.getFullYear()
  const month = currentDate.value.getMonth() + 1
  if (currentView.value === 'month') {
    return `${year}年${month}月`
  } else if (currentView.value === 'week') {
    const weekStart = new Date(currentDate.value)
    weekStart.setDate(currentDate.value.getDate() - currentDate.value.getDay())
    const weekEnd = new Date(weekStart)
    weekEnd.setDate(weekStart.getDate() + 6)
    return `${weekStart.getMonth() + 1}月${weekStart.getDate()}日 - ${weekEnd.getMonth() + 1}月${weekEnd.getDate()}日`
  } else {
    return `${year}年${month}月${currentDate.value.getDate()}日`
  }
})

const currentDayDate = computed(() => {
  return currentDate.value.toISOString().split('T')[0]
})

const today = new Date().toISOString().split('T')[0]
const currentHour = new Date().getHours()

// 周日期数据
const weekDates = computed(() => {
  const dates = []
  const start = new Date(currentDate.value)
  start.setDate(currentDate.value.getDate() - currentDate.value.getDay())

  for (let i = 0; i < 7; i++) {
    const date = new Date(start)
    date.setDate(start.getDate() + i)
    dates.push({
      date: date.toISOString().split('T')[0],
      weekday: weekDays[i],
      day: date.getDate(),
      isToday: date.toISOString().split('T')[0] === today
    })
  }
  return dates
})

// 日历天数据（月视图）
const calendarDays = computed(() => {
  const days = []
  const year = currentDate.value.getFullYear()
  const month = currentDate.value.getMonth()

  const firstDay = new Date(year, month, 1)
  const lastDay = new Date(year, month + 1, 0)

  // 上月日期
  const startDay = firstDay.getDay()
  const prevMonth = new Date(year, month, 0)
  for (let i = startDay - 1; i >= 0; i--) {
    const date = prevMonth.getDate() - i
    days.push({
      date,
      isCurrentMonth: false,
      isToday: false,
      fullDate: `${year}-${String(month).padStart(2, '0')}-${String(date).padStart(2, '0')}`,
      events: []
    })
  }

  // 当月日期
  for (let date = 1; date <= lastDay.getDate(); date++) {
    const fullDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`
    days.push({
      date,
      isCurrentMonth: true,
      isToday: fullDate === today,
      fullDate,
      events: filteredEvents.value.filter(e => e.date === fullDate)
    })
  }

  // 下月日期
  const remaining = 42 - days.length
  for (let date = 1; date <= remaining; date++) {
    days.push({
      date,
      isCurrentMonth: false,
      isToday: false,
      fullDate: `${year}-${String(month + 2).padStart(2, '0')}-${String(date).padStart(2, '0')}`,
      events: []
    })
  }

  return days
})

// 议程分组
const agendaGroups = computed(() => {
  const groups = []
  const todayStr = new Date().toISOString().split('T')[0]
  const weekLater = new Date()
  weekLater.setDate(weekLater.getDate() + 7)

  const todayEvents = filteredEvents.value.filter(e => e.date === todayStr)
  const upcomingEvents = filteredEvents.value.filter(e => e.date > todayStr && e.date <= weekLater.toISOString().split('T')[0])

  if (todayEvents.length > 0) {
    groups.push({ date: todayStr, label: '今天', events: todayEvents })
  }
  if (upcomingEvents.length > 0) {
    groups.push({ date: 'upcoming', label: '即将到来', events: upcomingEvents })
  }
  return groups
})

const agendaTitle = computed(() => {
  return currentDate.value.toLocaleDateString('zh-CN', { year: 'numeric', month: 'long', day: 'numeric' })
})

// 右键菜单项
const contextMenuItems = computed(() => {
  const items = [
    { key: 'add', label: '添加日程', icon: 'add', priority: 1 },
    { type: 'divider' },
    { key: 'edit', label: '编辑', icon: 'edit', priority: 2, disabled: !contextMenuEvent.value },
    { key: 'copy', label: '复制到明天', icon: 'copy', priority: 3, disabled: !contextMenuTarget.value?.fullDate },
    { type: 'divider' },
    { key: 'delete', label: '删除', icon: 'delete', danger: true, priority: 4, disabled: !contextMenuEvent.value }
  ]
  return items
})

// 方法
function switchView(view) {
  currentView.value = view
  // 切换视图时刷新数据
  fetchEvents()
}

function navigateDate(direction) {
  const newDate = new Date(currentDate.value)
  if (currentView.value === 'month') {
    newDate.setMonth(newDate.getMonth() + direction)
  } else if (currentView.value === 'week') {
    newDate.setDate(newDate.getDate() + (direction * 7))
  } else {
    newDate.setDate(newDate.getDate() + direction)
  }
  currentDate.value = newDate
  // 导航日期时刷新数据
  fetchEvents()
}

function goToToday() {
  currentDate.value = new Date()
}

function goToDate(dateStr) {
  currentDate.value = new Date(dateStr)
  switchView('day')
}

function selectDate(day) {
  selectedDate.value = {
    fullDate: day.fullDate,
    weekday: weekDays[new Date(day.fullDate).getDay()],
    events: day.events
  }
}

function getSelectedDateEvents() {
  if (!selectedDate.value) return []
  return filteredEvents.value.filter(e => e.date === selectedDate.value.fullDate)
}

function getWeekEvents(dateStr) {
  return filteredEvents.value.filter(e => e.date === dateStr)
}

function getDayEvents(dateStr) {
  return filteredEvents.value.filter(e => e.date === dateStr)
}

function handleTimeSlotClick(day, event) {
  if (event.target.classList.contains('h-12') || event.target.classList.contains('h-16')) {
    // 点击时间槽，创建新日程
    const rect = event.currentTarget.getBoundingClientRect()
    const y = event.clientY - rect.top
    const hour = Math.floor(y / 64)
    const minute = Math.round((y % 64) / 64 * 60 / 15) * 15

    const date = day?.date || currentDayDate.value
    const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`

    openCreateModalForDateTime(date, time)
  }
}

function openCreateModalForDate(dateStr) {
  eventForm.startDate = dateStr
  eventForm.endDate = dateStr
  eventForm.startTime = '09:00'
  eventForm.endTime = '10:00'
  eventForm.type = 'MEETING'
  eventForm.title = ''
  eventForm.location = ''
  eventForm.description = ''
  eventForm.attendees = []
  eventForm.attendeeUserIds = []
  eventForm.customerId = null
  eventForm.opportunityId = null
  eventForm.contractId = null
  eventForm.projectId = null
  eventForm.isAllDay = 0
  eventForm.priority = 2
  eventForm.isImportant = 0
  eventForm.reminderEnabled = 1
  eventForm.reminderBefore = 15
  eventForm.repeatType = 0
  eventForm.color = ''
  editingEvent.value = null
  validation.clearValidate()
  showCreateModal.value = true
}

function openCreateModalForDateTime(dateStr, timeStr) {
  openCreateModalForDate(dateStr)
  eventForm.startTime = timeStr
  eventForm.endTime = timeStr
}

// 开始日期变化处理
function onStartDateChange() {
  // 如果结束日期早于开始日期，自动调整为开始日期
  if (eventForm.endDate && eventForm.endDate < eventForm.startDate) {
    eventForm.endDate = eventForm.startDate
  }
  // 如果结束时间和开始日期相同，但结束时间早于开始时间，自动调整
  if (eventForm.endDate === eventForm.startDate && eventForm.endTime && eventForm.endTime < eventForm.startTime) {
    eventForm.endTime = eventForm.startTime
  }
}

// 开始时间变化处理
function onStartTimeChange() {
  // 如果结束日期与开始日期相同，且结束时间早于开始时间，自动调整
  if (eventForm.endDate === eventForm.startDate && eventForm.endTime && eventForm.endTime < eventForm.startTime) {
    eventForm.endTime = eventForm.startTime
  }
}

function openCreateModal() {
  const now = new Date()
  const dateStr = now.toISOString().split('T')[0]
  eventForm.startDate = dateStr
  eventForm.endDate = dateStr
  const startMinutes = Math.floor(now.getMinutes() / 15) * 15
  const endMinutes = (startMinutes + 30) % 60
  const endHours = now.getHours() + Math.floor((startMinutes + 30) / 60)
  eventForm.startTime = `${String(now.getHours()).padStart(2, '0')}:${String(startMinutes).padStart(2, '0')}`
  eventForm.endTime = `${String(endHours).padStart(2, '0')}:${String(endMinutes).padStart(2, '0')}`
  eventForm.type = 'MEETING'
  eventForm.title = ''
  eventForm.location = ''
  eventForm.description = ''
  eventForm.attendees = []
  eventForm.attendeeUserIds = []
  eventForm.customerId = null
  eventForm.opportunityId = null
  eventForm.contractId = null
  eventForm.projectId = null
  eventForm.isAllDay = 0
  eventForm.priority = 2
  eventForm.isImportant = 0
  eventForm.reminderEnabled = 1
  eventForm.reminderBefore = 15
  eventForm.repeatType = 0
  eventForm.color = ''
  editingEvent.value = null
  validation.clearValidate()
  showCreateModal.value = true

  nextTick(() => {
    modalRef.value?.focus()
  })
}

function viewEvent(event) {
  // 先显示基本信息，然后加载详情
  detailEvent.value = event
  showEventDetail.value = true

  // 获取日程详情
  detailLoading.value = true
  scheduleApi.getDetail(event.id).then(res => {
    if (res) {
      // 格式化参与人列表
      const attendeeList = res.attendees?.map(a => ({
        id: a.userId,
        userId: a.userId,
        userName: a.userName || '',
        avatar: a.avatar || '',
        role: a.role,
        status: a.status
      })) || []
      const attendeesStr = res.attendees?.map(a => a.userName || '').filter(Boolean).join('、') || ''

      // 格式化时间
      const formatDate = (dt) => dt ? new Date(dt).toISOString().split('T')[0] : ''
      const formatTime = (dt) => dt ? (dt.includes('T') ? dt.split('T')[1]?.substring(0, 5) : dt.substring(0, 5)) : ''

      // 合并详情数据
      detailEvent.value = {
        ...event,
        ...res,
        attendees: attendeesStr,
        attendeeList,
        // 格式化时间 (新API使用 startTime/endTime)
        date: res.startTime ? formatDate(res.startTime) : event.date,
        time: res.startTime ? formatTime(res.startTime) : event.time,
        endDate: res.endTime ? formatDate(res.endTime) : event.endDate,
        endTime: res.endTime ? formatTime(res.endTime) : event.endTime,
        // CRM关联
        customerName: res.customerName || '',
        opportunityName: res.opportunityName || '',
        contractName: res.contractName || '',
        projectName: res.projectName || '',
        // 保持拥有者信息
        isOwner: event.isOwner,
        attendeeStatus: event.attendeeStatus,
        // 创建和更新时间
        createdAt: res.createTime || event.createdAt || '',
        updatedAt: res.updateTime || event.updatedAt || ''
      }
    }
  }).catch(error => {
    console.error('[Schedule] 获取详情失败:', error)
  }).finally(() => {
    detailLoading.value = false
  })
}

function editEvent(event) {
  editingEvent.value = event
  showEventDetail.value = false
  showCreateModal.value = true

  // 填充表单（支持后端类型值）
  eventForm.title = event.title
  eventForm.type = event.typeBackend || event.type
  eventForm.location = event.location || ''
  eventForm.description = event.description || ''
  eventForm.startDate = event.date
  eventForm.startTime = event.time || '09:00'
  eventForm.endDate = event.endDate || event.date
  eventForm.endTime = event.endTime || event.time || '10:00'
  // CRM关联
  eventForm.customerId = event.customerId || null
  eventForm.opportunityId = event.opportunityId || null
  eventForm.contractId = event.contractId || null
  eventForm.projectId = event.projectId || null
  // 状态
  eventForm.isAllDay = event.isAllDay || 0
  eventForm.priority = event.priority || 2
  eventForm.isImportant = event.isImportant || 0
  eventForm.reminderEnabled = event.reminderEnabled || 1
  eventForm.reminderBefore = event.reminderBefore || 15
  eventForm.repeatType = event.repeatType || 0
  eventForm.color = event.color || ''
  // 参与人
  eventForm.attendees = event.attendeeList || []
  eventForm.attendeeUserIds = event.attendeeList?.map(a => a.id) || []
}

function saveEvent() {
  // 验证
  if (!validation.validate(eventForm)) {
    return
  }

  // 获取当前时间
  const now = new Date()
  const nowDate = now.toISOString().split('T')[0]
  const nowTime = now.toTimeString().substring(0, 5)

  // 验证开始日期不能早于今天
  if (eventForm.startDate < nowDate) {
    eventForm.startDate = nowDate
    eventForm.startTime = nowTime
    ElMessage.warning('开始日期不能早于今天，已自动调整为当前时间')
    return
  }

  // 如果开始日期是今天，开始时间不能早于当前时间
  if (eventForm.startDate === nowDate && eventForm.startTime < nowTime) {
    eventForm.startTime = nowTime
    ElMessage.warning('开始时间不能早于当前时间，已自动调整为当前时间')
    return
  }

  // 验证结束时间必须晚于开始时间且不能跨天
  if (eventForm.startDate && eventForm.startTime && eventForm.endDate && eventForm.endTime) {
    // 如果结束日期早于开始日期，自动调整为开始日期
    if (eventForm.endDate < eventForm.startDate) {
      eventForm.endDate = eventForm.startDate
      eventForm.endTime = eventForm.startTime
      ElMessage.warning('结束日期不能早于开始日期，已自动调整')
      return
    }

    const start = new Date(`${eventForm.startDate}T${eventForm.startTime}`)
    const end = new Date(`${eventForm.endDate}T${eventForm.endTime}`)

    // 如果结束时间早于或等于开始时间
    if (end <= start) {
      eventForm.endTime = ''
      ElMessage.warning('结束时间必须晚于开始时间')
      return
    }

    // 验证不能跨天
    if (eventForm.endDate !== eventForm.startDate) {
      eventForm.endDate = eventForm.startDate
      eventForm.endTime = ''
      ElMessage.warning('日程不能跨越多天')
      return
    }
  }

  saving.value = true

  // 构建API请求数据
  const startDateTime = eventForm.startDate && eventForm.startTime
    ? `${eventForm.startDate}T${eventForm.startTime}:00`
    : null
  const endDateTime = eventForm.endDate && eventForm.endTime
    ? `${eventForm.endDate}T${eventForm.endTime}:00`
    : startDateTime

  const data = {
    title: eventForm.title,
    type: eventForm.type,
    startDateTime,
    endDateTime,
    location: eventForm.location,
    description: eventForm.description,
    attendeeUserIds: eventForm.attendeeUserIds,
    customerId: eventForm.customerId,
    opportunityId: eventForm.opportunityId,
    contractId: eventForm.contractId,
    projectId: eventForm.projectId,
    isAllDay: eventForm.isAllDay,
    priority: eventForm.priority,
    isImportant: eventForm.isImportant,
    reminderEnabled: eventForm.reminderEnabled,
    reminderBefore: eventForm.reminderBefore,
    repeatType: eventForm.repeatType,
    color: eventForm.color || eventTypes.find(t => t.value === eventForm.type)?.color
  }

  const promise = editingEvent.value
    ? scheduleApi.update(editingEvent.value.id, data)
    : scheduleApi.create(data)

  promise.then(async (res) => {
    saving.value = false
    showCreateModal.value = false
    console.log('[Schedule] 创建/更新API响应:', res)

    if (editingEvent.value) {
      // 更新模式：重新获取详情
      const detailRes = await scheduleApi.getDetail(editingEvent.value.id)
      if (detailRes) {
        const newEvent = transformEvent(detailRes)
        const index = events.value.findIndex(e => e.id === editingEvent.value.id)
        if (index !== -1) {
          events.value[index] = newEvent
        }
      }
      ElMessage.success('更新成功')
    } else {
      // 创建模式：API返回的是新日程的ID
      const newId = typeof res === 'number' ? res : (res?.id || res?.data?.id)
      if (newId) {
        // 获取新创建的日程详情
        const detailRes = await scheduleApi.getDetail(newId)
        if (detailRes) {
          const newEvent = transformEvent(detailRes)
          events.value.push(newEvent)
          console.log('[Schedule] 新建成功，添加到列表:', newEvent)
        }
      } else {
        // 降级：本地创建
        const newIdLocal = Math.max(...events.value.map(e => e.id), 0) + 1
        events.value.push({
          id: newIdLocal,
          ...eventForm,
          date: eventForm.startDate,
          time: eventForm.startTime,
          duration: 60,
          color: eventTypes.find(t => t.value === eventForm.type)?.color || '#3B82F6'
        })
      }
      ElMessage.success('创建成功')
    }

    editingEvent.value = null
  }).catch((error) => {
    saving.value = false
    console.error('[Schedule] 保存失败:', error)
    ElMessage.error('保存失败')
  })
}

function confirmDelete(event) {
  deleteTarget.value = event
  showDeleteConfirm.value = true
  showEventDetail.value = false
  showCreateModal.value = false
}

function handleDelete() {
  if (!deleteTarget.value) return

  const eventId = deleteTarget.value.id

  scheduleApi.delete(eventId).then(() => {
    // 从列表中移除
    const index = events.value.findIndex(e => e.id === eventId)
    if (index !== -1) {
      events.value.splice(index, 1)
    }
    showDeleteConfirm.value = false
    deleteTarget.value = null
    ElMessage.success('删除成功')
  }).catch((error) => {
    console.error('[Schedule] 删除失败:', error)
    // 降级本地删除
    const index = events.value.findIndex(e => e.id === eventId)
    if (index !== -1) {
      events.value.splice(index, 1)
    }
    showDeleteConfirm.value = false
    deleteTarget.value = null
    ElMessage.success('删除成功')
  })
}

function closeModal() {
  showCreateModal.value = false
  editingEvent.value = null
  validation.clearValidate()
}

function handleContextMenu(e, day) {
  contextMenuX.value = e.clientX
  contextMenuY.value = e.clientY
  contextMenuTarget.value = day
  contextMenuEvent.value = null
  contextMenuVisible.value = true
}

function handleEventContextMenu(e, event) {
  contextMenuX.value = e.clientX
  contextMenuY.value = e.clientY
  contextMenuTarget.value = null
  contextMenuEvent.value = event
  contextMenuVisible.value = true
}

function handleContextMenuSelect(item) {
  if (item.key === 'add' && contextMenuTarget.value) {
    openCreateModalForDate(contextMenuTarget.value.fullDate)
  } else if (item.key === 'edit' && contextMenuEvent.value) {
    editEvent(contextMenuEvent.value)
  } else if (item.key === 'copy' && contextMenuTarget.value) {
    // 复制到明天
    const tomorrow = new Date(contextMenuTarget.value.fullDate)
    tomorrow.setDate(tomorrow.getDate() + 1)
    openCreateModalForDate(tomorrow.toISOString().split('T')[0])
  } else if (item.key === 'delete' && contextMenuEvent.value) {
    confirmDelete(contextMenuEvent.value)
  }
}

function validateField(field) {
  validation.validateField(field, eventForm)
}

// function toggleTask() {
//   // 可以在这里调用API更新状态
// }

// function deleteTask(taskId) {
//   const index = pendingTasks.findIndex(t => t.id === taskId)
//   if (index !== -1) {
//     pendingTasks.splice(index, 1)
//   }
// }

// function addQuickTodo() {
//   // 添加快速待办
// }

function scheduleWithContact(contact) {
  openCreateModal()
  eventForm.attendees.push({
    id: contact.id,
    name: contact.name,
    avatar: contact.avatar
  })
}

// 样式方法
function getEventClass(type) {
  const classes = {
    meeting: 'bg-blue-100 text-blue-800',
    call: 'bg-green-100 text-green-800',
    task: 'bg-amber-100 text-amber-800',
    deadline: 'bg-red-100 text-red-800',
    other: 'bg-slate-100 text-slate-800'
  }
  return classes[type] || classes.other
}

function getEventBorderClass(type) {
  const classes = {
    meeting: 'bg-blue-500',
    call: 'bg-green-500',
    task: 'bg-amber-500',
    deadline: 'bg-red-500',
    other: 'bg-slate-500'
  }
  return classes[type] || classes.other
}

function getTypeDotClass(type) {
  const classes = {
    meeting: 'bg-blue-500',
    call: 'bg-green-500',
    task: 'bg-amber-500',
    deadline: 'bg-red-500',
    other: 'bg-slate-500'
  }
  return classes[type] || classes.other
}

function getTypeBadgeClass(type) {
  const classes = {
    meeting: 'bg-blue-100 text-blue-700',
    call: 'bg-green-100 text-green-700',
    task: 'bg-amber-100 text-amber-700',
    deadline: 'bg-red-100 text-red-700',
    other: 'bg-slate-100 text-slate-700'
  }
  return classes[type] || classes.other
}

function getTypeLabel(type) {
  // 支持后端类型值(MEETING/TASK)和前端类型值(meeting/task)
  const backendType = type.toUpperCase()
  const labels = {
    MEETING: '会议',
    TASK: '任务',
    CALL: '电话',
    DEADLINE: '截止',
    OTHER: '其他',
    meeting: '会议',
    task: '任务',
    call: '电话',
    deadline: '截止',
    other: '其他'
  }
  return labels[type] || labels[backendType] || '其他'
}

function getEventStyle(event) {
  const [hours, minutes] = event.time.split(':').map(Number)
  const top = hours * 64 + (minutes / 60) * 64
  const height = (event.duration / 60) * 64
  return {
    top: `${top}px`,
    height: `${Math.max(height, 32)}px`
  }
}

function getDayEventStyle(event) {
  const [hours, minutes] = event.time.split(':').map(Number)
  const top = hours * 64 + (minutes / 60) * 64
  const height = (event.duration / 60) * 64
  return {
    top: `${top}px`,
    height: `${Math.max(height, 60)}px`
  }
}
</script>

<style scoped>
/* 自定义滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* 过渡动画 */
.modal-enter-active,
.modal-leave-active {
  transition: all 0.2s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from > div:last-child,
.modal-leave-to > div:last-child {
  transform: scale(0.95);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 拖拽样式 */
.dragging {
  cursor: grabbing !important;
}

.dragging * {
  cursor: grabbing !important;
}

/* 响应式 */
@media (max-width: 640px) {
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
